module.exports = __webpack_public_path__ + "static/img/VISA.793608c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/VISA.png
// module id = 1w4G
// module chunks = 1